import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";

export const LiveMapPlannedForNowTooltipStyled = styled.span.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "live-map-planned-for-now-tooltip",
  },
)`
  display: block;
  max-width: 500px;
  font-size: 11px;
  white-space: normal;
  overflow-wrap: break-word;
  text-align: start;
  line-height: 1.4;
`;

export const LiveMapGridStatusBreakdownRowStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "live-map-grid-status-breakdown-row",
  },
)`
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
`;

export const LiveMapGridStatusBreakdownStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "live-map-grid-status-breakdown",
  },
)`
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  line-height: 1.3;
`;
